import SkirtingBoardsInstallationInformation from "./SkirtingBoardsInstallationInformation";

export default SkirtingBoardsInstallationInformation